/**
 * English — the source dictionary and the site's default.
 *
 * Every other locale is typed against this shape (`Dict`), so a missing or
 * renamed key is a compile error rather than a blank space on the page.
 */
const en = {
  /** Shown in the language menu, always written in the language itself. */
  languageName: 'English',

  nav: {
    products: 'Products',
    team: 'Team',
    about: 'About',
    contact: 'Contact',
  },

  hero: {
    eyebrow: 'Vaqtly Holding',
    /* Split in three so the accent colour can sit on a different word in each
       language — word order will not survive a single interpolated string. */
    headlinePre: 'We build ',
    headlineAccent: 'products',
    headlinePost: ' people open every day.',
    body: 'Vaqtly is a holding company building digital products in Uzbekistan. Two startups are live today.',
    ctaPrimary: 'Our products',
    ctaSecondary: 'Get in touch',
  },

  products: {
    eyebrow: 'Products',
    heading: 'Startups under Vaqtly',
    visit: 'Visit site',
    status: {
      live: 'Live',
      beta: 'Beta',
      soon: 'Coming soon',
    },
  },

  team: {
    eyebrow: 'Team',
    heading: 'The people behind the products',
    body: 'Each product has its own small team, working on it end to end.',
    /** Heading of the first group — the holding itself, above the products. */
    founders: 'Company founders',
  },

  /** Job titles, keyed so `data/team` can stay free of language. */
  roles: {
    founder: 'Founder',
    cofounder: 'Co-founder',
    founderCeo: 'Founder & CEO',
    ceo: 'CEO',
    cto: 'CTO',
    engineer: 'Engineer',
    designer: 'Designer',
    product: 'Product',
    marketing: 'Marketing',
    content: 'Content',
    operations: 'Operations',
  },

  principles: {
    eyebrow: 'About us',
    heading: 'How we work',
    items: [
      {
        title: 'Opened every day',
        body: 'We build products that turn into a habit, not a one-off visit.',
      },
      {
        title: 'Local context',
        body: 'Our products start from a real need in Uzbekistan and speak Uzbek.',
      },
      {
        title: 'Small team, fast shipping',
        body: 'Not long roadmaps — we ship a working version early and learn from the people using it.',
      },
    ],
  },

  contact: {
    heading: 'Partnership or a question?',
    body: 'Write to the team directly — we read every message.',
  },

  footer: {
    tagline: 'Vaqtly Holding — a company building digital products.',
    products: 'Products',
    contact: 'Contact',
    about: 'About us',
    rights: 'All rights reserved.',
  },

  /** Per-product copy. Structural data (url, status, mark) lives in data/products. */
  product: {
    'russian-gg': {
      tagline: 'Speak Russian in 90 days.',
      description:
        'A speaking-first language platform. 15–20 minutes of voice practice a day, in real work ' +
        'and everyday situations, with support in Uzbek.',
    },
    sevil: {
      tagline: 'An AI stylist in your pocket.',
      description:
        'A personal stylist powered by AI. Style advice in Uzbek, straight from your phone.',
    },
  },
};

/* Deliberately not `as const`: the shape is what the other locales must match,
   not the English strings themselves. */
export type Dict = typeof en;
export default en;
